// @flow
import { useSelector } from "react-redux";

import type { State as AffiliatesState } from "state/reducers/affiliates";

type State = {
  affiliates: AffiliatesState,
};

function useDataSource(): Array<{ value: number, text: string }> {
  return useSelector<State, Array<{ value: number, text: string }>>((state) => {
    return Array.from(state.affiliates.items, ([key, value]) => ({
      value: key,
      text: `(${key}) ${value}`,
    }));
  });
}

export default useDataSource;
